import React, { useEffect, useState } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import S from './Solution.module.css';

import {  attend1, attend2, 
          attendSub1, attendSub2, attendSub3, attendSub4, attendSub5, attendSub6, attendSub7, attendSub8,
          btnImg1, btnImg2, btnImg3, btnImg4, btnImg5, btnImg6, btnImg7, btnImg8, 
          popup01, popup02, popup03, popup04, popup05, popup06, popup07, popup08, } from '../../assets/images/solution/solutionImages';
import ImgModal from '../../components/Modal/ImgModal';
import TextImgCard from '../../components/Card/TextImgCard';
import { attendHeaderData, attendBodytData } from './SolutionData';
import BasicTable from '../../components/Table/BasicTable';
import { Link } from 'react-router-dom';

const AttendPage = () => {

  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [modalImgData, setModalImgData] = useState();

  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  const closeDetailModal = () => {
    setIsDetailModalOpen(false);
    // document.body.style = `overflow: auto`;
  }

  const handleImgBtnClick = (popImg) => {
    setModalImgData(popImg);
    setIsDetailModalOpen(true);
  };



  return (
    <div>
      <HeaderComponents pageKey="solution" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="solution" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div style={{minHeight:'650px'}}>
            <div className='mb-50'>
              <img src={attend1} alt='workey' className={`${S.solContentImg} mt-30`}/>
            </div>
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                근태관리 솔루션 워키란?
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                근태관리 솔루션 워키는 지문인식 및 RFID 시스템을 기반으로 소규모 사업장부터 대규모 사업장까지 <br />
                임직원들의 출, 퇴근 및 휴가, 출장 일정관리등 다양한 활용이 가능한 근태관리 솔루션입니다.
              </div>
              <div>
                <img src={attend2} alt='workey2' className={`${S.solContentImg} mt-50`} />
              </div>
            </div>
            <div className='mt-10 mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                고객의 사용환경에 맞춰 다양한 장비 사용 가능
              </div>
              <div className={S.TextImgCardDiv}>
                <TextImgCard 
                  imgPath={attendSub1}
                  title='생체인식+RFID카드'
                  content={(<>지문인식(생체인식) RFID카드 인식 비밀번호<br />설정까지 가능한 멀티 단말기입니다.</>)}
                  imgClass='tcImg'
                  wrapClass='tcListDiv'
                  titleClass='textCardBasicTitle'
                  contentClass='textCardBasicContent'
                />
                <TextImgCard 
                  imgPath={attendSub2}
                  title='RFID카드'
                  content={(<>사원증(RFID카드)으로만 인식이 가능한<br />간편한 단말기입니다.</>)}
                  imgClass='tcImg'
                  wrapClass='tcListDiv'
                  titleClass='textCardBasicTitle'
                  contentClass='textCardBasicContent'
                />
              </div>
            </div>
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
              근태관리 솔루션 워키 기능 및 특징
              </div>
              <div className={S.textCardWkBtnWrap}>
                <div className={S.textCardWkBtnDivWrap}>
                  <TextImgCard imgPath={btnImg1} title={(<>실시간A/S 원격, 백업지원</>)} wrapClass='textCardWkBtnDiv' titleClass='textCardWkBtnTitle' func={()=>{handleImgBtnClick(popup01)}}/>
                  <TextImgCard imgPath={btnImg2} title='경제적인 가격' wrapClass='textCardWkBtnDiv' titleClass='textCardWkBtnTitle' func={()=>{handleImgBtnClick(popup02)}}/>
                  <TextImgCard imgPath={btnImg3} title='간편한 프로그램 설치' wrapClass='textCardWkBtnDiv' titleClass='textCardWkBtnTitle' func={()=>{handleImgBtnClick(popup03)}}/>
                </div>
                <div className={S.textCardWkBtnDivWrap}>
                  <TextImgCard imgPath={btnImg4} title='편리한 일정관리' wrapClass='textCardWkBtnShortDiv' titleClass='textCardWkBtnTitle' func={()=>{handleImgBtnClick(popup04)}}/>
                  <TextImgCard imgPath={btnImg5} title='실시간 근태보고(문자발송기능)' wrapClass='textCardWkBtnShortDiv2' titleClass='textCardWkBtnTitle' func={()=>{handleImgBtnClick(popup05)}}/>
                </div>
                <div className={S.textCardWkBtnDivWrap}>
                  <TextImgCard imgPath={btnImg6} title='간편한 보고서 다운로드' wrapClass='textCardWkBtnShortDiv' titleClass='textCardWkBtnTitle' func={()=>{handleImgBtnClick(popup06)}}/>
                  <TextImgCard imgPath={btnImg7} title='쉬운 근태시간 설정' wrapClass='textCardWkBtnShortDiv' titleClass='textCardWkBtnTitle' func={()=>{handleImgBtnClick(popup07)}}/>
                  <TextImgCard imgPath={btnImg8} title='사용이 쉬운 UI' wrapClass='textCardWkBtnShortDiv' titleClass='textCardWkBtnTitle' func={()=>{handleImgBtnClick(popup08)}}/>
                </div>
              </div>
              <div className='mt-40'>
                <BasicTable headers={attendHeaderData} items={attendBodytData} />
              </div>
            </div>
            <div className='mt-10 mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                근태관리 솔루션 워키 구성품
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                근태관리 솔루션은 리더기(3종 중 택1) 근태 소프트웨어, RFID 사원증으로 구성되어 있습니다.
              </div>
              <div className={S.TextImgCardDiv}>
                <TextImgCard 
                  imgPath={attendSub3}
                  title='하드웨어'
                  content={(<>근태관리 솔루션에<br />사용 가능한 전용 RFID 리더기 </>)}
                  imgClass='tcImg'
                  wrapClass='tcListDiv'
                  titleClass='textCardBasicTitle'
                  contentClass='textCardBasicContent'
                />
                <TextImgCard 
                  imgPath={attendSub4}
                  title='소프트웨어'
                  content={(<>설치부터 사용법까지 간편한<br />근태관리 솔루션 워키 프로그램</>)}
                  imgClass='tcImg'
                  wrapClass='tcListDiv'
                  titleClass='textCardBasicTitle'
                  contentClass='textCardBasicContent'
                />
                <TextImgCard 
                  imgPath={attendSub5}
                  title='추가구성'
                  content={(<>RFID 기능이 탑재된<br />다양한 종류의 사원증 인쇄카드 (별도구매)</>)}
                  imgClass='tcImg'
                  wrapClass='tcListDiv'
                  titleClass='textCardBasicTitle'
                  contentClass='textCardBasicContent'
                />
              </div>
            </div>
            <div className='mt-10 mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                RFID 리더기
              </div>
              <div className={S.TextImgCardDiv}>
                <TextImgCard 
                  imgPath={attendSub6}
                  title='F7Plus'
                  content={(<>사이즈 : 86 x 187 x 35mm<br />지문 저장공간 : 3,000개<br />RF카드 저장공간 : 5,000개<br />통신연결방식 : RS232, 485, TCP/IP, USB-Host<br />정격전압 : 12V DC, 3A</>)}
                  imgClass='tcImg'
                  wrapClass='tcListDiv'
                  titleClass='textCardBasicTitle'
                  contentClass='textCardBasicContent'
                />
                {isMobile() ? (
                  <>
                    <div className={S.mbCardWrapDiv}>
                      <div>
                        <Link to={'/product/detail?idx=69&list=1'}>
                          <img src={attendSub7}/>
                        </Link>
                      </div>
                      <div>
                        <Link to={'/product/detail?idx=108&list=1'}>
                          <img src={attendSub8}/>
                        </Link>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <Link to={'/product/detail?idx=69&list=1'}>
                      <TextImgCard imgPath={attendSub7} imgClass='tcImg' wrapClass='tcListDiv' titleClass='textCardBasicTitle' contentClass='textCardBasicContent' />
                    </Link>
                    <Link to={'/product/detail?idx=108&list=1'}>
                      <TextImgCard imgPath={attendSub8} imgClass='tcImg' wrapClass='tcListDiv' titleClass='textCardBasicTitle' contentClass='textCardBasicContent' />
                    </Link>
                  </>
                )}
              </div>
            </div>
            
            {isDetailModalOpen && (
              <ImgModal isOpen={isDetailModalOpen} onClose={closeDetailModal} img={modalImgData}/>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendPage;
